import { createSlice } from "@reduxjs/toolkit";

// The period grain of the two Key Accounts Over Time tabs (per-country and
// Global). It lives here rather than in either tab's local state because the
// tabs reset their filters on every franchise or country change and the grain
// must survive those; it resets only when the workspace changes. The slice
// records the workspace it belongs to, so the reset fires on the first page
// that sees a new workspace, whichever page the switch happened on.
const initialState = {
  // The workspace key the grains below were set under; null until a page syncs.
  workspaceKey: null,
  // 'month' | 'quarter' | 'year' for Key Accounts › Over Time
  period: "month",
  // 'month' | 'quarter' | 'year' for Global Key Accounts › Over Time
  globalPeriod: "month",
};

const keyAccountsSlice = createSlice({
  name: "keyAccounts",
  initialState,
  reducers: {
    setPeriod: (state, action) => {
      state.period = action.payload;
    },
    setGlobalPeriod: (state, action) => {
      state.globalPeriod = action.payload;
    },
    // Called by each page with the active workspace key. A different key
    // means a workspace switch, so both grains return to Month.
    // A page that has not resolved its workspace yet sends null, which must
    // not read as a switch away from the persisted key.
    syncWorkspace: (state, action) => {
      const key = action.payload ?? null;
      if (!key || state.workspaceKey === key) return;
      state.workspaceKey = key;
      state.period = "month";
      state.globalPeriod = "month";
    },
  },
});

export const { setPeriod, setGlobalPeriod, syncWorkspace } = keyAccountsSlice.actions;

export const selectKeyAccountsPeriod = (state) => state.keyAccounts?.period ?? "month";
export const selectGlobalKeyAccountsPeriod = (state) => state.keyAccounts?.globalPeriod ?? "month";

export default keyAccountsSlice.reducer;
